module.exports = __webpack_public_path__ + "img/play-or-pause-button.f282571a.png";